import styled from "styled-components";
import themes from "@/styles/themes";
import { useMemo } from "react";
import Input from "../Input";

const LabelAlert = styled.label`
  pointer-events: none;
  color: ${themes.red};
  font-size: 16px;
  position: absolute;
  top: 15px;
  right: 15px;
  transition: all .3s ease-out;
  -webkit-transition: all .3s ease-out;
  -moz-transition: all .3s ease-out;
  display: none;
`

const FormGroup = styled.div`
  position: relative;

  &.group-invalid {
    input.input {
      
      border: 1px solid ${themes.red} !important;

    }

    span.error {
      color: ${themes.redDark};
      font-size: 12px;
      margin: 0;
      padding: 0;
    }

    ${LabelAlert} {
      display: block;
    }
  }

  &.group-valid {
    input.input {
      border: 1px solid ${themes.green};
      box-shadow: 0 0 5px ${themes.green};
    }

    span.error {
      display: none;
    }
  }

  input.input {
    border: 1px solid #707070;
    border-radius: 5px;
    outline: none;
    width: 100%;
    font-size: 16px;
    transition: all .3s ease-out;
    -webkit-transition: all .3s ease-out;
    -moz-transition: all .3s ease-out;
    -webkit-appearance: none;
    margin-top: 8px;
    height: 44.4px;
    text-align: center;

    &:focus {
      box-shadow: 0 0 0 2px rgba(37, 117, 232, .3);
    }

    &::placeholder {
      color: #bbbbbb;
    }
  }
`

export default function InputTelefone(parent: any) {
  const second = useMemo((): string => {
    if(parent.errorMessage === null){
      return ''
    }

    if(parent.errorMessage === ''){
      return 'group-valid'
    }

    return 'group-invalid'
  }, [parent])

  return <FormGroup className={second}>
    <Input
      onChange={parent.onChange}
      masks={['(00) 0000-0000', '(00) 0 0000-0000']}
      name={parent.name}
      className={`input ${parent.name} ${parent.className}`}
      type={parent.type}
      placeholder={parent.placeholder}
      onClick={parent.onClick}
    />
    {parent.errorMessage && <span className={'error'}>{parent.errorMessage}</span>}
  </FormGroup>
}